
import { SparklesIcon } from '@heroicons/react/outline'
import Image from "next/image"
import Meta from '../components/Meta';
import Layout from '../components/Layouts/homeLayout'
import AlertTemplate from '../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import { useAuth, AuthProvider } from '../contexts/Auth'
import Link from "next/link"
const data = [
    {name: 'Samantha', type:'nutrition'},
    {name: 'Jess', type:'weight loss nutrition'},
    {name: 'Joceline', type:'postnatal dieting'}

]

const listings = [
  "branding",
  "beauty",
  "cooking"
]

export default function Directory() {


    return (
        <>
         <Meta 
                title="Plaza Directory"
                description="Find coaches online - more coming soon"
                
                />
          <section className="pt-10 bg-slate-200/50 h-full -mt-0 sm:pt-10 lg:pt-0 lg:pb-14  mb-2 sm:mb-40 md:mb-40 lg:mb-0">
            <div className="mx-auto max-w-7xl lg:px-8">
              <div className="flex items-center">
              
                  <div className="lg:pb-10 text-center mx-10 sm:mx-72">
                    {/* <a
                      href="#"
                      className="inline-flex items-center text-white bg-black rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200"
                    >
                      <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-fuchsia-700 rounded-full">
                        Beta
                      </span>
                      <span className="ml-4 text-sm">We just launched!</span>
                      <ChevronRightIcon className="ml-2 w-5 h-5 text-gray-600" aria-hidden="true" />
                    </a> */}
                    <span className='text-fuchsia-700 bg-fuchsia-100 w-16 px-2 py-1 rounded-lg font-bold flex items-center justify-between'><SparklesIcon className="h-5 w-5"/> Beta</span>
                    <h1 className="mt-4 text-5xl tracking-tight font-extrabold mb-10 text-black sm:mt-5 sm:text-6xl lg:mt-2 xl:text-5xl">
                      <span className="block "> <span className="text-fuchsia-600">Launching Soon</span></span>
                      <span className="block ">  <span className="underline decoration-fuchsia-600 decoration-wavy decoration-4">Live Coaching Directory</span></span>
                    </h1>
                    <div className="blur-3xl  -ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-500"/>

                    <p className="mt-3 text-base text-gray-700 mb-5 sm:text-xl lg:text-lg xl:text-xl ">
                        Find online coaches for personalized support in nutrition, fitness, dating, and business
                     
                    </p>
               
                  </div>
    
             
      
              </div>
              <div className="w-full sm:w-1/2 justify px-10 sm:px-0 mx-auto flex items-center mb-20">
                      <div className='bg-white border-2 p-5 rounded-lg w-full '>
                        <h2 className='font-extrabold text-2xl text-slate-700 '>Available Coaches</h2>
                        {listings.map((str, index) => (
                          <div className='mt-3' key={index}>
                              <Link href={`/coaches/${str}`}><a className='hover:underline text-slate-600 '>{str}</a></Link>
                          </div>
                        ))}
                        <div className='text-slate-700 mt-20 text-center'>More Coming Soon...</div>

        
                         
                        </div>

                
             
                </div>

                <div className="w-full sm:w-1/2 justify px-10 sm:px-0 mx-auto flex items-center mb-20">
                      <div className='bg-white border-2 p-5 rounded-lg w-full '>
                        <h2 className='font-extrabold text-2xl text-slate-700 '>Request a coach</h2>
                        <p>Let us know in the chat if you are looking for a specific type of coach and we&apos;ll see if we can match you</p>
                      </div>

                
             
                </div>
            </div>
            <div className='relative bottom-0 w-full flex justify-center'>
            <p className="text-center w-96 text-gray-400">© 2023 Ordinary Media, LLC. All Rights Reserved.</p>

            </div>

     
          </section>

        </>
      
    );
}


const alertOptions = {
  // you can also just use 'bottom right'
  position: positions.BOTTOM_RIGHT,
  timeout: 3000,
  offset: '10px',
  containerStyle: {'zIndex':'9999'},
  // you can also just use 'fade'
  transition: transitions.FADE,
}


Directory.getLayout = function getLayout(page) {
  return (
      <AlertProvider template={AlertTemplate} {...alertOptions}>
          <AuthProvider>
              <Layout>
                  {page}
              </Layout>
          </AuthProvider>
      </AlertProvider>
  )
}